import { atom, useAtomValue, useSetAtom } from 'jotai'

/**
 * The tour's offer, published for the chat input's `before` slot to render.
 *
 * The tour decides *whether* to offer; the slot decides *where* it sits. They
 * are in different subtrees — the tour is mounted by the Meeting View, the slot
 * by the chat input — and the offer belongs above the input, which is the one
 * place the view can put a card without the footer chrome painting over it.
 *
 * Shaped like {@link FloatingBarScrollSlot}: the handlers travel with the
 * claim, so the slot renders the card without knowing what it offers.
 */
export interface MeetingTourPromptSlot {
  onAccept: () => void
  onDecline: () => void
}

const meetingTourPromptSlotAtom = atom<MeetingTourPromptSlot | null>(null)

export const useMeetingTourPromptSlot = () => useAtomValue(meetingTourPromptSlotAtom)

export const useSetMeetingTourPromptSlot = () => useSetAtom(meetingTourPromptSlotAtom)
